import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { Constants } from '~/app/core/configs/constants';
import { NotificationService } from '~/app/core/services/notification.service';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss']
})
export class NotificationComponent implements OnInit {
  @Input()set notifications(value) {
    let noticheck = [];
    if(value && value.length) {
      value.forEach(noti => {
        const msgUri = `${noti.message}${noti.uri}`;
        if(noticheck.indexOf(msgUri) == -1) {
          noticheck.push(msgUri);
          if(noti.readStatus == false) {
            this.notificationService.updateNotification(noti?.id);
            noti.readStatus == true;
          }
        }
      })
    }
    this.data = value;
  };
  prevNotifyId: string;
  timeFormat = Constants.TimeFormat;
  data: any = [];


  constructor(
    private notificationService: NotificationService,
    private router: Router,
  ) { }

  get loaded(): boolean {
    return this.notificationService.loaded;
  }

  ngOnInit(): void {
  }

  formatDate(value: string): string {
    const date = moment(new Date(value), Constants.DateFormat);
    const now = moment(new Date(), Constants.DateFormat);
    const isDiff = date.diff(now, 'days');
    const yesterday = now.subtract(1, 'days');

    if (isDiff === 0) {
      return 'TODAY';
    } else if (yesterday.diff(date, 'days') === 0) {
      return 'YESTERDAY';
    } else {
      return new Date(value).toLocaleDateString();
    }
  }

  getTime(seconds): string {
    return moment(new Date(seconds * 1000)).format(Constants.TimeFormat);
  }

  async viewDetails(notify): Promise<void> {
    const url = notify?.uri;
    if (notify?.readStatus === 'false') {
      await this.notificationService.updateNotification(notify?.id);
    }
    if (!url) { return; }
    this.router.navigate(['/']);
    setTimeout(() => {
      this.router.navigateByUrl(url);
    });
  }

  onScroll(): void {
    this.notificationService.loadMoreNotification();
  }
}
